import { useStaticQuery, graphql } from 'gatsby'

export const useSeoApiData = () => {
  const {
    site,
    customSlugsApi: { values: slugsData },
  } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            description
            author
          }
        }
        customSlugsApi {
          values {
            lang
            slugs {
              generic_route
              language_route
              href_langs {
                url
                href_lang
              }
            }
          }
        }
      }
    `
  )

  return { site, slugsData }
}
